
import axios from 'axios'
import { from, Observable, pipe} from 'rxjs'
import { mergeMap,tap, map  } from 'rxjs/operators';

const apiserver = axios.create({
  baseURL: '/api',
  timeout: 30000
});

const handleDefaultResponse = (response) => {
  return Observable.create((obs) => {
    let valid = true; // check for valid responses
    if (valid) {
      obs.next(response.data);
      obs.complete()
    } else {
      obs.error(response)
    }
  })
};

const responseToObservable = mergeMap(handleDefaultResponse);

const requestToObservable = (promise) =>  from(promise).pipe(responseToObservable);

export const urlReplaceParams = (url, params) => {
  return Object.keys(params).reduce( (acc, p) => {
    return acc.replace(new RegExp('(:' + p +'($|/))|(^:' + p + ')',"g"), params[p] + "$2")
  }, url)
};

const apiGet    = (url, data  = {}) => requestToObservable(apiserver.get(urlReplaceParams(url,data), { params: data,
  headers: {Authorization: localStorage.getItem('pogs-user-token')}}));
const apiPost   = (url, data) => requestToObservable(apiserver.post(urlReplaceParams(url,data), data, {
  headers: {Authorization: localStorage.getItem('pogs-user-token')}}));
const apiPut    = (url, data) => requestToObservable(apiserver.put(urlReplaceParams(url,data), data, {
  headers: {Authorization: localStorage.getItem('pogs-user-token')}}));
const apiDelete = (url, data) => requestToObservable(apiserver.delete(urlReplaceParams(url,data), data));


const mutateData = (context, mutationName) => (data) => {
  context.commit(mutationName, data)
};

const mutateResult = (requestFunc,mutationName, transformFunc) => (context, payload) => {
  let t  = transformFunc ? (data) => transformFunc(data, payload) : data => data;
  let m  = mutateData(context,mutationName);
  let op = mutationName
         ? pipe( map(t), tap(m))
         : tap( () => {} );
  return requestFunc(payload).pipe(op).toPromise()
};

export default{
  apiGet,
  apiPut,
  apiPost,
  apiDelete,
  mutateResult
}
